<template>
  <div class="pin-input-wrapper">
    <input
      v-for="index in parseInt(size, 10)"
      :key="index"
      type="tel"
      ref="inputs"
      v-on:keyup="handleKeyup(index - 1, $event)"
      maxlength="2"
      :index="index"
      aria-label="Please enter you pin code"
      autocomplete="off"
    />
    <input aria-hidden="true" type="hidden" ref="hiddenInput" />
  </div>
</template>
<script>
const BACK_SPACE = 8;
const ARROW_LEFT = 37;
const ARROW_RIGHT = 39;
const ENTER_KEY = 13;

export default {
  name: "PINInput",
  props: {
    size: {
      default: 4,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.focusOnFirstInput();
    });
  },
  methods: {
    clear() {
      const inputs = this.$refs.inputs || [];

      inputs.forEach((input) => {
        input.value = "";
      });

      this.$refs.hiddenInput.value = "";
    },
    focusOnFirstInput() {
      const [firstInput] = this.$refs.inputs || [];

      if (firstInput) {
        firstInput.focus();
      }
    },
    clearValue(value) {
      return value.replace(/\D/g, "");
    },
    focusInPrevious(inputs, index) {
      const previous = inputs[index - 1];

      if (previous) {
        previous.focus();
      }
    },
    focusInNext(inputs, index) {
      const nextInput = inputs[index + 1];

      if (nextInput) {
        nextInput.focus();
      }
    },
    arrowNavigation(event, index, inputs) {
      if (event.keyCode === ARROW_LEFT) {
        this.focusInPrevious(inputs, index);
      } else if (event.keyCode === ARROW_RIGHT) {
        this.focusInNext(inputs, index);
      }
    },
    handleKeyup(index, event) {
      const inputs = this.$refs.inputs || [];

      if ([ARROW_LEFT, ARROW_RIGHT].includes(event.keyCode)) {
        this.arrowNavigation(event, index, inputs);
        return;
      }

      const lastValue = event.target.getAttribute("lastValue") || "";
      const values = this.clearValue(event.target.value).split("");
      const singleValue =
        values.find((value) => value !== lastValue) || values[0] || "";

      event.target.value = singleValue;
      event.target.setAttribute("lastValue", singleValue);

      if (singleValue.length === 1 && event.keyCode !== BACK_SPACE) {
        this.focusInNext(inputs, index);
      } else if (event.keyCode === BACK_SPACE && singleValue.length === 0) {
        this.focusInPrevious(inputs, index);
      }

      const value = inputs.map((input) => input.value).join("");

      this.$refs.hiddenInput.value = value;
      this.$emit("input", value);

      if (
        index === inputs.length - 1 &&
        value.length === parseInt(this.size, 10)
      ) {
        this.$emit("filled");
      }

      if (event.keyCode === ENTER_KEY) {
        this.$emit("enter", value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pin-input-wrapper {
  display: inline-flex;
  gap: 5px;
  cursor: pointer;

  > input {
    background-color: transparent;
    color: #fff;
    outline: 0;
    width: 36px;
    height: 36px;
    border: 0;
    border-bottom: 1px solid #fff;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    user-select: none;
  }
}
</style>
